export interface MyApplication {
  key: string;
  displayName: string;
  description: string | null;
  launchUrl: string;
  iconName: string | null;
  accentColor: string | null;
  sortOrder: number;
  roles: string[];
}

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}

type GetToken = () => Promise<string | null>;

async function call<T>(getToken: GetToken, path: string): Promise<T> {
  const token = await getToken();
  const res = await fetch(path, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    let message = `${res.status}`;
    try {
      const payload = (await res.json()) as { message?: string };
      if (payload.message) message = payload.message;
    } catch {
      /* no body */
    }
    throw new ApiError(res.status, message);
  }
  return (await res.json()) as T;
}

export function createPortalApi(getToken: GetToken) {
  return {
    listMyApplications: () => call<MyApplication[]>(getToken, "/api/my/applications"),
  };
}

export type PortalApi = ReturnType<typeof createPortalApi>;
